export const Category = [
    { value: 'empty', label: '--Select--' },
    { value: 'IT', label: 'IT' },
    { value: 'Language', label: 'Language' },
    { value: 'Science', label: 'Science' },
    { value: 'Health', label: 'Health' },
    { value: 'Humanities', label: 'Humanities' },
    { value: 'Business', label: 'Business' },
    { value: 'Maths', label: 'Maths' },
    { value: 'Marketing', label: 'Marketing' },

]
export const Instructor = [
    { value: 'empty', label: '--Select--' },
    { value: 'Pedro Cox', label: 'Pedro Cox' },
    { value: 'Vera Guzman', label: 'Vera Guzman' },
    { value: 'Glenda Long', label: 'Glenda Long' },
    { value: 'Joel Anderson', label: 'Joel Anderson' },
    { value: 'Blanche Henderson', label: 'Blanche Henderson' },
]

